function arrayHasTrue(arr) {
  if (!Array.isArray(arr)) return false;

  return arr.some(obj => {
    if (typeof obj === 'object' && obj !== null) {
      // check if any attribute is true
      return Object.values(obj).some(v => v === true);
    }
    return obj === true;
  });
}

function hasTrueAttribute(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  return Object.values(obj).some(value => value === true);
}

const getDirtyValues = (dirtyItems, data) => {
  const dirtyItemsEntries = Object.entries(dirtyItems);

  return dirtyItemsEntries.reduce((dirtyData, [name, value]) => {
    if (typeof value === 'boolean') {
      if (value === true) {
        return { ...dirtyData, [name]: data?.[name] };
      }
      return dirtyData;
    }

    const isArray = Array.isArray(value);
    const isObject = typeof value === 'object';

    if (isArray) {
      const hasTrue = arrayHasTrue(value);
      if (hasTrue) {
        return { ...dirtyData, [name]: data?.[name] };
      }
      return dirtyData;
    }

    if (!isArray && isObject) {
      const hasTrue = hasTrueAttribute(value);
      if (hasTrue) {
        return { ...dirtyData, [name]: data?.[name] };
      }
      return dirtyData;
    }
    return dirtyData;
  }, {});
};

export default getDirtyValues;
